import { render, staticRenderFns } from "./UpsellCard.vue?vue&type=template&id=7d2a8a44&scoped=true&"
import script from "./UpsellCard.vue?vue&type=script&lang=js&"
export * from "./UpsellCard.vue?vue&type=script&lang=js&"
import style0 from "./UpsellCard.vue?vue&type=style&index=0&id=7d2a8a44&prod&lang=scss&"
import style1 from "./UpsellCard.vue?vue&type=style&index=1&id=7d2a8a44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2a8a44",
  null
  
)

export default component.exports